var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-form',{staticStyle:{"margin":"40px auto 0"}},[_c('result',{attrs:{"title":_vm.$t('更改密码成功'),"is-success":true}},[_c('div',{staticClass:"toLogin"},[_c('h3',[_vm._v(_vm._s(_vm.$t('将在{time}秒后返回登录页面.', { time: _vm.time })))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }